<template>
    <div class="car-edit-form-wrapper">
        <div class="car-form-title">
            Данные вашего автомобиля
        </div>
        <div class="car-form-title-caption">
            <span class="required">*</span> — обязательное поле
        </div>
        <v-form v-model="isValidForm" lazy-validation ref="carForm" class="car-form-container">
            <v-container class="car-form">

                <!-- <div class="car-form-element marka">
                    <div class="subheader">
                        Марка <span class="required">*</span>
                    </div>
                    <v-autocomplete
                        :items="[]"
                        solo
                        outlined
                        hide-details
                    />
                </div> -->
                <div class="car-form-element model">
                    <div class="subheader">
                        Модель <span class="required">*</span>
                    </div>
                    <v-autocomplete
                        v-model="carModel"
                        :items="carModels"
                        item-text="name"
                        item-value="id"
                        return-object
                        :rules="[rules.required]"
                        outlined
                        hide-details
                    />
                </div>
                <div class="car-form-element vin">
                    <div class="subheader">
                        VIN-код или номер кузова
                    </div>
                    <v-text-field
                        v-model="car.vin"
                        solo
                        outlined
                        hide-details
                        placeholder="Введите VIN или номер кузова"
                    />
                </div>
                <div class="car-form-element nomer">
                    <div class="subheader">
                        Номерной знак
                    </div>
                    <v-text-field
                        v-model="car.numberPlate"
                        solo
                        outlined
                        hide-details
                        placeholder="Х000ХХ00"
                    />
                </div>
                <div class="car-form-element yearManufacture">
                    <div class="subheader">
                        Год выпуска
                    </div>
                    <v-text-field
                        v-model="car.yearManufacture"
                        solo
                        outlined
                        hide-details
                        placeholder="Год"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        step="any"
                        type="number"
                    />
                </div>
                <div class="car-form-element mileage">
                    <div class="subheader">
                        Пробег
                    </div>
                    <v-text-field
                        v-model="car.mileage"
                        solo
                        outlined
                        hide-details
                        placeholder="Пробег, км"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        step="any"
                        type="number"
                    />
                </div>
                <div class="car-form-element bodyType">
                    <div class="subheader">
                        Тип кузова
                    </div>
                    <v-text-field
                        v-model="car.bodyType"
                        solo
                        outlined
                        hide-details
                        placeholder="Кузов"
                    />
                </div>
                <div class="car-form-element engineCapacity">
                    <div class="subheader">
                        Объем двигателя
                    </div>
                    <v-text-field
                        v-model="car.engineCapacity"
                        solo
                        outlined
                        hide-details
                        placeholder="Введите объем двигателя, л"
                    />
                </div>
                <div class="car-form-element color">
                    <div class="subheader">
                        Цвет
                    </div>
                    <v-text-field
                        v-model="car.color"
                        solo
                        outlined
                        hide-details
                        placeholder="Выберите цвет авто"
                    />
                </div>
            </v-container>
            <!-- <v-container>
                <v-row>
                    <v-col cols="12">
                        <v-autocomplete
                            v-model="carModel"
                            :items="carModels"
                            item-text="name"
                            item-value="id"
                            label="Модель"
                            return-object
                            :rules="[rules.required]"
                        />
                    </v-col>
                </v-row>
                <v-subheader>Свойства</v-subheader>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="car.vin"
                            :label="fieldLabels.vin"
                        />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                            v-model="car.yearManufacture"
                            inputmode="numeric"
                            :label="fieldLabels.yearManufacture"
                            pattern="[0-9]*"
                            step="any"
                            type="number"
                        />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                            v-model="car.numberPlate"
                            :label="fieldLabels.numberPlate"
                            hint="А111АА72"
                            persistent-hint
                        />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                            v-model="car.color"
                            :label="fieldLabels.color"
                        />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                            v-model="car.engineCapacity"
                            :label="fieldLabels.engineCapacity"
                        />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                            v-model="car.bodyType"
                            :label="fieldLabels.bodyType"
                        />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                            v-model="car.mileage"
                            inputmode="numeric"
                            :label="fieldLabels.mileage"
                            pattern="[0-9]*"
                            step="any"
                            type="number"
                        />
                    </v-col>
                </v-row>
                <v-divider/>
                <v-row>
                    <v-col cols="12">
                        <v-btn
                            block
                            color="secondary"
                            :disabled="isSaving"
                            :loading="isSaving"
                            @click="saveCar()"
                        >
                            Сохранить
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container> -->
            <v-btn
                class="add-car-btn"
                elevation="0"
                :disabled="isSaving"
                :loading="isSaving"
                @click="saveCar()"
            >
                Добавить
            </v-btn>
        </v-form>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex'

    import CarModel from '@/models/CarModel'
    import CarModelModel from '@/models/CarModelModel'

    export default {
        name: 'GarageCarEditScreen',

        data: () => ({
            car: new CarModel(),
            carModel: new CarModelModel(),

            isValidForm: true,
            rules: {
                string: value => (!!value && !!(value.trim())) || 'Обязательное поле',
                required: value => !!value || 'Обязательное поле',
            },
        }),

        computed: {
            ...mapState('car', {
                isSaving: (state) => state.isSaving,
            }),

            ...mapGetters({
                carModels: 'carModel/getCarModels',
            }),

            fieldLabels() {
                return CarModel.attributeLabels
            },

            carId() {
                return this.$route.params?.carId
            },
        },

        methods: {
            async saveCar() {
                if (this.$refs.carForm.validate()) {
                    const client = {
                        // Если найден в 1С
                        id: this.$store.state.client.client?.id,
                        // Если не найден в 1С
                        phone: this.$store.state.client.client?.phone,
                    }

                    const carModel = this.carModel
                    const car = this.car

                    const data = {
                        client,
                        carModel,
                        car,
                    }

                    try {
                        if (car?.id) {
                            // Update
                            await this.$store.dispatch('car/updateCar', data)
                        } else {
                            // Create
                            await this.$store.dispatch('car/createCar', data)
                        }
                    } catch (e) {
                        console.log(e)
                    }

                    this.$router.back()
                }
            },
        },
    }
</script>

<style>
    .mobile .car-edit-form-wrapper {
        padding: 16px;
    }
    .car-form {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0;
    }
    .car-form .car-form-element {
        width: 283px;
        margin-bottom: 12px;
    }
    .mobile .car-form .car-form-element {
        width: 100%;
        margin-bottom: 14px;
    }
    .mobile .car-form :last-child {
        margin-bottom: 0;
    }
    .car-form .subheader {
        color: #36393B;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
        margin-left: 2px;
    }
    .car-form .subheader .required {
        color: #DA251C;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
    }

    .car-form .v-input {
        border-radius: 8px;
        background: #FFF;
    }
    .car-form input {
        color: #36393B;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 140%;
    }
    .car-form .v-input .v-input__slot {
        box-shadow: none !important;
    }

    .car-form .v-input fieldset {
        border: 1.5px solid #F3F4F4 !important;
    }
    .car-form .v-select__slot .v-icon svg {
        color: #36393B !important;
    }

    .car-form .car-form-element.marka {
        margin-right: 3px;
        width:100%;
        max-width:100%;
        flex: 0 0 100%;
    }

    .mobile .car-form .car-form-element.marka {
        margin-right: 3px;
        width:100%;
        max-width:49%;
        flex: 0 0 50%;
    }
    .mobile .car-form .car-form-element.model {
        margin-left: 4px;
        width:100%;
        max-width:100%;
        flex: 0 0 100%;
    }
    .mobile .car-form .car-form-element.yearManufacture {
        margin-right: 3px;
        margin-left: 0;
        width:100%;
        max-width:48%;
        flex: 0 0 50%;
    }
    .car-form .car-form-element.yearManufacture {
        /* margin-right: 3px; */
        width:100%;
        max-width:11.5%;
        flex: 0 0 50%;
    }
    .mobile .car-form .car-form-element.mileage {
        margin-left: 4px;
        width:100%;
        max-width:49%;
        flex: 0 0 50%;
    }
    .car-form .car-form-element.mileage {
        /* margin-left: 4px; */
        width:100%;
        max-width:11.5%;
        flex: 0 0 50%;
    }
    .car-form-title {
        color: #36393B;
        font-size: 22px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
    }
    .car-form-title-caption {
        margin-top: 8px;
        margin-bottom: 20px;
        color: #8F8F8F;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
    .car-form-title-caption .required {
        color: #DA251C;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
    }
    .mobile .car-form-title {
        color: #36393B;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
    }
    .mobile .car-form-title-caption {
        margin-bottom: 16px;
        color: #8F8F8F;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
    .mobile .car-form-title-caption .required {
        color: #DA251C;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
    .car-form-container .add-car-btn {
        display: flex;
        padding: 16px 40px !important;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 10px;
        background: #DA251C !important;
        width: 153px;
        height: 54px !important;
        color: #FFF !important;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
        margin-top: 32px;
    }
    .mobile .car-form-container .add-car-btn {
        display: flex;
        padding: 16px 40px !important;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 10px;
        background: #DA251C !important;
        width: 100%;
        height: 50px !important;
        color: #FFF !important;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
        margin-top: 12px;
    }

</style>
